const expression = /(\d)(?=(\d{3})+(?!\d))/g;

export default expression